/***
 *
 *   LANDING CAPABILITIES
 *   Four-up feature grid.
 *
 **********/

import { Icon } from 'components/lib';
import { useTranslate } from 'app/translations';
import Shared from './landing.tailwind.js';
import Style from './capabilities.tailwind.js';

/* key into landing.capabilities.* paired with its feather icon.
   `analytics` used to sit third, selling volume / resolution / team-load
   dashboards with period comparison — a V2 design. There is no analytics view;
   what ships is the stats band above the tickets board, so the slot now reads
   `metrics` and the copy claims only that. */
const CAPABILITIES = [
    { key: 'kanban', icon: 'trello' },
    { key: 'contacts', icon: 'users' },
    { key: 'metrics', icon: 'activity' },
    { key: 'collaboration', icon: 'message-square' },
];

export function LandingCapabilities(props) {
    const { _t } = useTranslate();

    return (
        <section id="capabilities" className={Shared.sectionSurface}>
            <div className={Shared.container}>
                <div className={Shared.eyebrow}>{_t('landing.capabilities.eyebrow')}</div>
                <h2 className={Shared.title}>{_t('landing.capabilities.title')}</h2>
                <p className={Style.lede}>{_t('landing.capabilities.lede')}</p>

                <div className={Style.grid}>
                    {CAPABILITIES.map((capability) => (
                        <div key={capability.key}>
                            <div className={Style.well}>
                                <Icon image={capability.icon} size={18} color="hsl(var(--primary-600))" />
                            </div>

                            <h3 className={Style.title}>
                                {_t(`landing.capabilities.${capability.key}.title`)}
                            </h3>
                            <p className={Style.desc}>
                                {_t(`landing.capabilities.${capability.key}.desc`)}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
